'use client';
const composeOptions = {
    pickEventFromArgs: (...args)=>args[1]
};

export { composeOptions };
//# sourceMappingURL=composeOptions.js.map
